
import axios from 'axios';
// eslint-disable-next-line import/no-unresolved, import/no-extraneous-dependencies, import/extensions
import config from 'config';

const qs = require('qs');

const state = {
	integrations: {},
};
const actions = {
	setIntegrations: ({ commit, rootState }, payload) => {
		const str = qs.stringify(payload);
		return new Promise((resolve, reject) => {
			axios.post(`${config.api}/politician/${rootState.userId}/votolegal-integration?api_key=${rootState.apiKey}`, str)
				.then((response) => {
					resolve(response);
					commit('setSuccess');
				})
				.catch((error) => {
					reject(error);
					commit('setError', error.response.data, { root: true });
					commit('statusCheck', error.response.status);
				});
		});
	},
	setPicframe: ({ commit, rootState }, payload) => {
		const str = qs.stringify(payload);
		return new Promise((resolve, reject) => {
			axios.put(`${config.api}/politician/${rootState.userId}?api_key=${rootState.apiKey}`, str)
				.then((response) => {
					resolve(response);
					commit('setSuccess');
				})
				.catch((error) => {
					reject(error);
					commit('setError', error.response.data, { root: true });
					commit('statusCheck', error.response.status);
				});
		});
	},
};

const mutations = {
	// eslint-disable-next-line no-shadow
	setIntegrations(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.contacts = payload;
	},
};


export default {
	state,
	actions,
	mutations,
};



// WEBPACK FOOTER //
// ./_source/javascripts/modules/integrations/store.js